import api from 'mastodon/api';
import { showAlert } from 'mastodon/actions/alerts';
import { openModal } from 'mastodon/actions/modal';

const messages = {
  copied: { id: 'share_modal.copied', defaultMessage: 'Link copied' },
  sent: { id: 'share_modal.sent', defaultMessage: 'Sent' },
  failed: { id: 'share_modal.failed', defaultMessage: 'Unable to share' },
};

export const openShareModal = statusId => ({
  type: 'MODAL_OPEN',
  payload: {
    modalType: 'SHARE',
    modalProps: { statusId },
  },
});

export const openShareModalThunk = statusId => dispatch => {
  dispatch(openModal({ modalType: 'SHARE', modalProps: { statusId } }));
};

const fallbackCopy = value => {
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

export const copyStatusLink = statusUrl => async dispatch => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(statusUrl);
    } else {
      fallbackCopy(statusUrl);
    }

    dispatch(showAlert({ message: messages.copied }));
  } catch {
    dispatch(showAlert({ message: messages.failed }));
  }
};

export const fetchLaoChatRecentContacts = async () => {
  if (window.LaoApp?.getRecentContacts) {
    return window.LaoApp.getRecentContacts();
  }

  const { data } = await api().get('/api/v1/laochat/recent_contacts');
  return data;
};

export const sendLaoChatDM = (contactId, statusUrl) => async dispatch => {
  try {
    if (window.LaoApp?.sendDM) {
      await window.LaoApp.sendDM(contactId, statusUrl);
    } else {
      await api().post('/api/v1/laochat/send_dm', {
        recipient_id: contactId,
        post_url: statusUrl,
      });
    }

    dispatch(showAlert({ message: messages.sent }));
  } catch {
    dispatch(showAlert({ message: messages.failed }));
  }
};
